import React, { useEffect } from 'react';
import './AuthModal.css';
import loginBg from './../../assets/signup-bg.jpg';
import AuthSideContent from './AuthSideContent';

function AuthModal({ isOpen, onClose, children }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;






  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="auth-modal-close" onClick={onClose}>
          ×
        </button>
        
        {/* Left Side - Image Background */}
        <div className="auth-modal-left">
          <AuthSideContent backgroundImage={loginBg} />
        </div>

        {/* Right Side - Form */}
        <div className="auth-modal-right">
          <div className="auth-modal-form-container">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
